import React from 'react';
import {FeatureFlag} from 'react-launch-darkly';
import BusinessEmail from '../business_email';

function handleLoginRedirect() {
    window.location.href = `${sn_brands_app_url}/brands/login`;
    return <div />;
}

function checkLoginRedirectFeatureFlag() {
    return (
        <FeatureFlag flagKey="brand-login-redirect" renderFeatureCallback={handleLoginRedirect} />
    );
}

function PasswordInput(props) {
    return (
        <div className="form-group">
            <input
                className="form-control"
                placeholder="Password"
                type="password"
                name="password"
                id="password"
            />
        </div>
    );
}

function ForgotPasswordLink(props) {
    return (
        <div>
            <a className="brand-gateway-forgot-password pull-right" href="/forgot_password">
                Forgot your password?
            </a>
        </div>
    );
}

function SubmitFormButton(props) {
    return (
        <button className="btn btn-lg btn-primary btn-block btn-brand-gateway" type="submit">
            Log In
        </button>
    );
}

export default function LoginForm(props) {
    const socialStudioMode = !!props.socialStudioMode;
    const actionUrl = socialStudioMode ? '/brand/socialstudio/do_login' : '/login';
    return (
        <form className="omb_loginForm" role="form" method="POST" action={actionUrl}>
            <input type="hidden" name="_token" value={csrf_token} />
            <BusinessEmail email={email} />
            <PasswordInput />
            {socialStudioMode ? null : <ForgotPasswordLink />}
            {checkLoginRedirectFeatureFlag()}
            <SubmitFormButton />
        </form>
    );
}



// WEBPACK FOOTER //
// ./brand/login/form.js